import { useContext, createContext } from 'react';
import { Item } from './types';

export const AutoSuggestGroupContext = createContext<{
  item?: Item;
}>({
  item: undefined,
});

export default function useAutoSuggestGroupContext() {
  const context = useContext(AutoSuggestGroupContext);
  if (!context) {
    throw new Error(
      'AutoSuggestGroup compound components cannot be rendered outside the AutoSuggestGroup component',
    );
  }
  return context;
}
